<template>
    <popup-modal
        :closeOnClick="!working"
        :has-close-button="hasCloseButton"
        :without-padding="true"
        position="center"
        @close="close"
    >
        <template v-if="fetchingData">
            <div :class="withoutPadding ? '' : deleteAction ? 'p-28 pb-32' : 'p-48'">
                <loading/>
            </div>
        </template>
        <template v-else>
            <div :class="withoutPadding ? '' : deleteAction ? 'p-28 pb-32' : 'p-48'"
                 class="sm:flex sm:items-start"
            >
                <!--                <div v-if="deleteAction"-->
                <!--                     class="mx-auto shrink-0 flex items-center justify-center h-48 w-48 rounded-32 bg-semantic-error-light sm:mx-0 sm:h-40 sm:w-40 sm:mr-18"-->
                <!--                >-->
                <!--                    <svg aria-hidden="true" class="h-24 w-24 text-semantic-error" fill="none" stroke="currentColor"-->
                <!--                         viewBox="0 0 24 24" x-description="Heroicon name: outline/exclamation"-->
                <!--                         xmlns="http://www.w3.org/2000/svg">-->
                <!--                        <path-->
                <!--                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"-->
                <!--                            stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>-->
                <!--                    </svg>-->
                <!--                </div>-->

                <div class="mt-6 text-center sm:mt-0 sm:text-left">
                    <strong class="first-letter:uppercase block text-heading-1 mb-8 max-w-480">
                        <template v-if="!title && deleteAction">
                            {{ $t('general.delete') }}?
                        </template>
                        <template v-else>
                            {{ title }}
                        </template>
                    </strong>

                    <div :class="showBig ? 'max-w-640' : 'max-w-480'"
                         class="text-body text-primary-80 sm:mr-32 max-w-480"
                         v-html="message"></div>

                    <slot/>

                    <checkbox v-if="toggleText" v-model="canConfirm" class="flex justify-center mb-16">{{
                            toggleText
                        }}
                    </checkbox>
                </div>
            </div>

            <div class="bg-primary-5 py-16 px-24 space-y-16 sm:space-y-0 sm:flex sm:flex-row-reverse">
                <button v-if="showConfirmButton"
                        :class="confirmationButton"
                        :disabled="!canConfirm || disabled"
                        class="w-full sm:w-auto flex items-center justify-center sm:ml-16 rounded text-white px-20 py-8 text-body first-letter:uppercase"
                        role="button"
                        @click="confirm">
                    {{ confirmationText }}

                    <svg-icon v-if="working" class="animate-spin w-20 h-20 ml-10 -mr-12" size="small" type="loader"/>
                </button>

                <button v-if="showCancelButton"
                        :class="cancellationButton"
                        :disabled="working || disabled"
                        class="w-full sm:w-auto text-center rounded px-20  py-8 text-body first-letter:uppercase"
                        role="button"
                        @click="close">
                    {{ cancellationText }}
                </button>
            </div>
        </template>
    </popup-modal>
</template>

<script>
import PopupModal from "./PopupModal.vue";
import SvgIcon from "./SvgIcon";
import Checkbox from "../forms/Checkbox";
import SimpleButton from "./SimpleButton";
import Loading from "./Loading";
import _upperFirst from "lodash/upperFirst";

export default {
    props: {
        title: String,
        message: String,
        action: Function,
        confirmButton: {type: String, default: ''},
        cancelButton: {type: String, default: ''},
        confirmText: String,
        cancelText: String,
        showConfirmButton: {type: Boolean, default: true},
        showCancelButton: {type: Boolean, default: true},
        working: Boolean,
        fetchingData: Boolean,
        disabled: Boolean,
        showBig: Boolean,
        toggleText: String,
        translatableType: Object,
        hasCloseButton: {type: Boolean, default: false},
        withoutPadding: {
            type: Boolean,
            default: false,
        },
        swapButtonLogic: {type: Boolean, default: false}, //Use this to swap button colors but keep the functionality
    },
    components: {
        SvgIcon,
        Checkbox,
        'popup-modal': PopupModal,
        'simple-button': SimpleButton,
        'loading': Loading,
    },
    data() {
        return {
            canConfirm: !this.toggleText,
        };
    },
    computed: {
        deleteAction() {
            return !(this.swapButtonLogic || this.cancelButton === 'success' || this.confirmButton === 'success');
        },
        cancellationButton() {
            if (this.swapButtonLogic) {
                this.cancelButton = 'success';
            }

            return (this.cancelButton === 'success' ? 'bg-secondary-80 hover:bg-secondary text-white' : this.cancelButton) || 'bg-white hover:bg-primary-5 shadow';
        },
        confirmationButton() {
            if (this.swapButtonLogic) {
                this.confirmButton = 'bg-white hover:bg-primary-5 text-primary-80 shadow';
            }

            return (this.confirmButton === 'success' ? 'bg-secondary-80 hover:bg-secondary' : this.confirmButton) || 'bg-semantic-error hover:bg-semantic-error';
        },
        confirmationText() {
            return _upperFirst(this.confirmText || this.$t('general.confirm'));
        },
        cancellationText() {
            return _upperFirst(this.cancelText || this.$t('general.cancel'));
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
        },
    },
};
</script>

<style scoped>

</style>
